module.exports = __webpack_public_path__ + "assets/img/advertising-placement.1b68b336.jpg";